export const initialValues = {
  projectDetails: {
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    dealType: '',
    proposedUnits: '',
    projectByRight: '',
    constructionType: '',
    acquisitionType: '',
    siteControlStatus: '',
    acquisitionCostEstimate: '',
    developmentCostEstimate: '',
    preDevelopmentCostEstimate: '',
    moreInfo: '',
    additionalDocs: [],
  },
  developmentTeam: [],
  developmentSchedule: {
    schedule1: { startDate: '', finishDate: '' },
    schedule2: { startDate: '', finishDate: '' },
    schedule3: { startDate: '', finishDate: '' },
    schedule4: { startDate: '', finishDate: '' },
    schedule5: { startDate: '', finishDate: '' },
  },
  applicantInformation: {
    entityName: '',
    ein: '',
    contactPersonName: '',
    contactPersonEmail: '',
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    phone: '',
    website: '',
    formationDate: '',
    fullTimeEmployeeCount: '',
    anyApply: [],
  },
  leadershipInformation: {
    racialEthnicGroup: [],
    majorityOwnership: [],
    boardOfDirectorsPercent: {
      communityMembersPercent: '',
      hispanicLatinxPercent: '',
      blackAfricanAmericanPercent: '',
      asianPacificIslandersPercent: '',
      nativeAmericanPercent: '',
      whiteCaucasianPercent: '',
      multiRacialPercent: '',
    },
    principalsResume: [],
  },
  experience: {
    companyCompleted: [],
    principalCompleted: [],
  },
};
